import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListKwhCell } from '@app/feature/transaction/transaction-list/transaction-list-kwh.cell';
import { TransactionListKwhHeader } from '@app/feature/transaction/transaction-list/transaction-list-kwh.header';

export const ChargePointChannelTransactionListKwhColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['kwh']
> = {
  enableSorting: false,
  header: TransactionListKwhHeader,
  cell: TransactionListKwhCell,
};
